import React, { Component } from "react";

import styles from "./userUnitBar.module.scss";
import UserUnitItem from "./UserUnitItem";
import { withUsers } from "../../../../shared/containers/containerUsers";

class UserUnitsListItems extends Component {


  render() {
    const { handleScrollTo, data, currentUser } = this.props;

    if (currentUser === null) {
      return null;
    }

    return data.map((item) => {
      /*   const isCheck = currentUser.units.some((x) => {
        return x.id === item.id;
      });
 */
      return (
        <div className={styles.container_userUnitsListItem} key={item.id}>
          <UserUnitItem data={item} handleScrollTo={handleScrollTo} />
        </div>
      );
    });
  }
}

export default withUsers(React.memo(UserUnitsListItems));
